/* created by CoolGuy on 2018/11/25 */
import React from 'react';

export default props => (
  <div className={'red-pack-wrapper'}>
    <div className="red-pack-main">
      <img
        src={require('../../assets/redpack/redpack-x.png')}
        alt="close"
        className={'red-pack-x'}
        onClick={props.onClose}
      />
      {props.children}
    </div>
  </div>
);
